export function isChinese(char: string) {
  return /[\u4e00-\u9fa5]/.test(char);
}
